var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 104 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.3085 58.027V72.5338H103.815V79.6374H89.3085V95H82.2049V79.6374H67.6982V72.5338H82.2049V58.027H89.3085ZM91.9148 0C94.5647 0 96.7117 2.15184 96.7117 4.80174V48.3559H89.6081V7.1036H7.1036V42.2341V79.9321L58.027 29.0135L72.5338 43.5203V54.6326L58.027 40.1258L18.2062 79.9369H58.027V87.0406H3.94104C2.66838 87.0393 2.30414 86.5328 1.40469 85.6324C0.505232 84.7321 -6.45334e-07 84.3673 0 83.0947V3.94588C0.00884933 2.67595 0.516925 2.31633 1.41447 1.41788C2.31202 0.519428 2.67112 0.0101289 3.94104 0H91.9148ZM29.0135 19.3423C31.5785 19.3423 34.0384 20.3613 35.8521 22.175C37.6657 23.9887 38.6847 26.4486 38.6847 29.0135C38.6847 31.5785 37.6657 34.0384 35.8521 35.8521C34.0384 37.6658 31.5785 38.6847 29.0135 38.6847C26.4486 38.6847 23.9887 37.6658 22.175 35.8521C20.3613 34.0384 19.3423 31.5785 19.3423 29.0135C19.3423 26.4486 20.3613 23.9887 22.175 22.175C23.9887 20.3613 26.4486 19.3423 29.0135 19.3423Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.5de2f61d.svg";
export { ForwardRef as ReactComponent };